/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import apiClient from "../../lib/common/apiClient";
import DeleteRecordButtonLayout from "../layout/DeleteRecordButtonLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";

function MomSysMstMaterialFileDeleteButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, grid, onSuccess, onFailure, onNotifyWarning, ...others} = props;
    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {
        setOpen(true);
        let data = grid.selectedItems[0];

        setConfirmMsg(t("dialog.msg.confirm.materialFile", {id: data.id, materialCode: data.materialCode}));
        setConfirmData(data);

        setOpen(true);
    };

    const materialFileDeleteSuccess = (msg) => {
        if(onSuccess) {
            onSuccess(msg);
        }
        refresh.refresh();
    };

    const onClose = () => {
        setOpen(false);
    };

    const onOk = (data) => {
        let url = `/api/MomSysMstMaterialFile/delete`;
        let json = {};
        let apiData = {...data};
        let form = new FormData();

        for ( const formItem in apiData ) {
            if ( apiData[formItem] !== undefined ) {
                json[formItem] = apiData[formItem];
            }
        }

        form.append("json", JSON.stringify(json));
        apiClient
            .post (url, form)
            .then((result) => {materialFileDeleteSuccess(result.data)})
            .catch((reason) => {
                console.error(reason);                
                onFailure(t("error.deleteFailure", {reason: reason.response ? reason.response.data : reason}));
            });

    }

    return (
        <>
            <DeleteRecordButtonLayout id={id+"delete-button"} onClick={onOpen} {...others} />
            <ConfirmDialog
                id={id+"delete-confirm-dialog"}
                title={schema ? t (`dialog.title.${schema.name}.delete`) : ""}
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onOk}
                onCancel={onClose}
            />
        </>
    );
}

export default MomSysMstMaterialFileDeleteButton;

